














































import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import {formatCurrency, formatDuration} from "@/helpers/functions_asi";
import Report from "@/models/report/Report";
import ReportSimple from "@/models/report/ReportSimple";
import ReportLineListEntry from "@/models/reportLine/ReportLineListEntry";

@Component
export default class ReportLinesList extends Vue {

	@Prop({type: Object, required: true})
	public report!: Report;

	private get hasLineWithNullValue(): boolean {
		if (this.report === null) return true;
		return this.report.reportLines.find(rl => rl.amount === null) !== undefined;
	}

	// noinspection JSMethodCanBeStatic
	private formatCurrencyAmount(amount: number | null): string | null {
		return formatCurrency(amount ?? 0);
	}

	private hourlyRateDescription(line: ReportLineListEntry): string {
		const duration = ReportSimple.calculateWorkingDurationMinutes(this.report);

		return this.$t('uiTerms.hourlyRateCalculation', {
			duration: formatDuration(duration),
			hourlyRate: formatCurrency(line.hourlyRate),
		}).toString();
	}

	private dailyLumpSumDescription(line: ReportLineListEntry): string {
		return this.$t('uiTerms.dailyLumpSum').toString() + ' (' + formatCurrency(line.dailyLumpSum) + ')';
	}

}
